export default "__VITE_ASSET___PA549rw__"